import React, { Suspense, lazy } from 'react';
import { Box } from '@mui/material';
import { pickRouteLoader } from './pickRouteLoader';
import {
  ROUTE_LOADER_FULL_HEIGHT,
  ROUTE_LOADER_KIND,
  ROUTE_SUSPENSE_FALLBACK_SX,
} from './routeLoader.constants';

const LOADER_IMPORTS = {
  [ROUTE_LOADER_KIND.FLIGHT]: () => import(/* webpackChunkName: "route-loaders" */ './FlightLoader'),
  [ROUTE_LOADER_KIND.HOTEL]: () => import(/* webpackChunkName: "route-loaders" */ './HotelLoader'),
  [ROUTE_LOADER_KIND.TRAIN]: () => import(/* webpackChunkName: "route-loaders" */ './TrainLoader'),
};

const LOADERS = {
  [ROUTE_LOADER_KIND.FLIGHT]: lazy(LOADER_IMPORTS[ROUTE_LOADER_KIND.FLIGHT]),
  [ROUTE_LOADER_KIND.HOTEL]: lazy(LOADER_IMPORTS[ROUTE_LOADER_KIND.HOTEL]),
  [ROUTE_LOADER_KIND.TRAIN]: lazy(LOADER_IMPORTS[ROUTE_LOADER_KIND.TRAIN]),
};

/** Grey page shell shows at once; the branded loader streams in from its own chunk. */
class RouteSuspenseFallback extends React.Component {
  static preloadLoaders() {
    return Promise.all(Object.values(LOADER_IMPORTS).map((load) => load()));
  }

  readSavedForm() {
    try {
      return window.localStorage.getItem('yovo_active_form_type');
    } catch {
      return null;
    }
  }

  render() {
    const { kind, fullHeight } = pickRouteLoader(this.props.pathname, this.readSavedForm());
    const Loader = LOADERS[kind];
    const loaderProps = fullHeight ? { minHeight: ROUTE_LOADER_FULL_HEIGHT } : {};

    return (
      <Box sx={ROUTE_SUSPENSE_FALLBACK_SX} data-testid="route-suspense-fallback">
        <Suspense fallback={null}>
          <Loader active {...loaderProps} />
        </Suspense>
      </Box>
    );
  }
}

export default RouteSuspenseFallback;
